import { useContext } from 'react';
import { MenuCountersContext } from './MenuCountersContext';

const useMenuCounters = () => useContext(MenuCountersContext);

export default useMenuCounters;
